import { useEffect } from 'react';

import { Route, Routes, useLocation } from 'react-router-dom';

import './App.css';
import Footer from './components/footer';
import Home from './screens/home';
import Login, { LoginAdmin } from './screens/login';
import Results from './components/results';
import SearchBar from './components/search_bar';
import { useJiang } from './utils/JiangContext';

function App() {
  const { loading, results } = useJiang();

  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return (
    <div className='App' style={{
      // To make footer be pushed to the bottom by making other components use flexGrow
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/search' element={
          <>
            <SearchBar />
            {!loading ? <Results results={results} /> : null}
          </>
        } />
        <Route path='/login' element={<Login />} />
        <Route path='/login-admin' element={<LoginAdmin />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
